function noop() {
}

// const log = console.log;
const log = noop;

export class Speaker {
    constructor(text, voice) {
        this._text = text;
        this._voice = voice;
    }

    say(startCallback, finishCallback) {
        const utterance = new window.SpeechSynthesisUtterance();
        utterance.voice = this._voice;
        utterance.lang = this._voice.lang;
        utterance.text = this._text;
        utterance.volume = 1;
        utterance.pitch = 1;
        utterance.rate = 1;

        utterance.addEventListener('start', function () {
            log('Speaker started');
            (startCallback || noop)();
        });

        utterance.addEventListener('end', function () {
            log('Speaker finished');
            (finishCallback || noop)();
        });

        utterance.addEventListener('error', function (event) {
            log('An error has occurred with the speech synthesis: ' + event.error);
            (finishCallback || noop)();
        });

        const speechSynthesis = window.speechSynthesis;

        speechSynthesis.cancel();
        speechSynthesis.speak(utterance);
    }
}

const AVAILABLE = 'speechSynthesis' in window;
let VOICES = [];

function reloadVoicesIfEmpty() {
    if (AVAILABLE && VOICES.length === 0) {
        VOICES = window.speechSynthesis.getVoices();
    }
}

reloadVoicesIfEmpty();

function findVoice(langPrefix) {
    const selection = VOICES.filter(voice => voice.lang.startsWith(langPrefix));
    if (selection.length) {
        return selection[0];
    }
    return null;
}

export class SpeakerFactory {
    static get enabled() {
        return AVAILABLE && VOICES.length > 0;
    }

    /**
     * @param text
     * @param lang
     * @return {object} true if engine is available
     */
    static create(text, lang) {
        if (!AVAILABLE) {
            return null;
        }

        let voice = null;
        if (voice === null && lang === 'en') {
            voice = findVoice(lang + '-US');
        }
        if (voice === null && lang === 'en') {
            voice = findVoice(lang + '_US');
        }
        if (voice === null) {
            voice = findVoice(lang);
        }
        if (voice === null) {
            voice = findVoice('en');
        }
        return voice ? new Speaker(text, voice) : null;
    }

    static cancel() {
        if (!AVAILABLE) {
            return;
        }
        window.speechSynthesis.cancel();
    }

    static addReadyCallback(fn) {
        if (!AVAILABLE) {
            return;
        }

        if (!fn) {
            fn = noop;
        }

        const handler = {
            called: false,
            invoke: function () {
                if (!this.called) {
                    this.called = true;
                    fn();
                }
            }
        };

        reloadVoicesIfEmpty();

        if (VOICES.length) {
            handler.invoke();
        } else {
            window.speechSynthesis.addEventListener('voiceschanged', () => {
                log('got voices!');
                VOICES = window.speechSynthesis.getVoices();
                handler.invoke();
            });
        }
    }
}